import { useContext } from "react";
import { clientContext } from "./clientContext";
var useClientContext = function(key) {
    var context = useContext(clientContext);
    if (!Object.prototype.hasOwnProperty.call(context, key)) {
        return {
            hasContext: false
        };
    }
    return {
        hasContext: true,
        value: context[key]
    };
};
export { useClientContext };
